<div class="container contact-container">
  <!-- Page Header -->
  <div class="page-header">
    <div class="header-content">
      <div class="header-icon">
        <i class="fas fa-envelope"></i>
      </div>
      <div class="header-text">
        <h2 class="page-title">Contact Us</h2>
        <p class="page-subtitle">Get in touch with us for any queries or assistance</p>
      </div>
    </div>
  </div>

  <div class="contact-content">
    <div class="row contact-row">
      <div class="col-lg-6 contact-col">
        <!-- Contact Info Card -->
        <div class="card info-card">
          <div class="card-header">
            <i class="fas fa-map-marker-alt me-2"></i>
            <span>Reach Us</span>
          </div>
          <div class="card-body">
            <!-- Contact Details -->
            <div class="contact-details">
              <div class="contact-item">
                <div class="contact-icon">
                  <i class="fas fa-map-marked-alt"></i>
                </div>
                <div class="contact-info">
                  <h6>Address</h6>
                  <p>College of Pharmacy (poly.), Akluj<br>
                     Tal: Malshiras, Dist: Solapur<br>
                     Pin: 413 101</p>
                </div>
              </div>

              <div class="contact-item">
                <div class="contact-icon">
                  <i class="fas fa-phone-alt"></i>
                </div>
                <div class="contact-info">
                  <h6>Contact Number</h6>
                  <p><a href="tel:02185223402">9421069625</a></p>
                </div>
              </div>

              <div class="contact-item">
                <div class="contact-icon">
                  <i class="fas fa-envelope"></i>
                </div>
                <div class="contact-info">
                  <h6>Email</h6>
                  <p><a href="mailto:copakluj1993@gmail.com">copakluj1993@gmail.com</a></p>
                </div>
              </div>
            </div>

            <!-- Google Map -->
            <div class="map-container">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3797.1850740970895!2d75.02559821440798!3d17.87679759321151!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc4745715555555%3A0x1f3bb9b1b1b72ecb!2sShikshan+Prasarak+Mandal%E2%80%99s+College+of+Pharmacy!5e0!3m2!1sen!2sin!4v1472680781658"
                width="100%" height="300" frameborder="0" style="border:0;border-radius:10px;" allowfullscreen="" loading="lazy"></iframe>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6 contact-col">
        <!-- Contact Form Card -->
        <div class="card form-card">
          <div class="card-header">
            <i class="fas fa-question-circle me-2"></i>
            <span>Ask Us</span>
          </div>
          <div class="card-body">
            <form class="contact-form">
              <div class="mb-3">
                <label>
                  <i class="fas fa-user me-1"></i>Name
                </label>
                <input name="name" required="required" class="form-control" type="text" placeholder="Enter your name">
              </div>

              <div class="mb-3">
                <label>
                  <i class="fas fa-phone me-1"></i>Contact Number
                </label>
                <input name="contactNo" required="required" class="form-control" type="tel" placeholder="Enter your contact number">
              </div>

              <div class="mb-3">
                <label>
                  <i class="fas fa-envelope me-1"></i>Email
                </label>
                <input name="email" required="required" class="form-control" type="email" placeholder="Enter your email">
              </div>

              <div class="mb-3">
                <label>
                  <i class="fas fa-comment-dots me-1"></i>What you want to know
                </label>
                <textarea name="message" required="required" class="form-control" rows="5" placeholder="Type your message here..."></textarea>
              </div>

              <div class="form-actions">
                <button type="submit" class="btn btn-submit">
                  <i class="fas fa-paper-plane me-2"></i>Send Message
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>